// extracted by mini-css-extract-plugin
export default {"root":"OrganicResultsTable_root__LWwC0","headless":"OrganicResultsTable_headless__PnIRl","header":"OrganicResultsTable_header__63wTy","title":"OrganicResultsTable_title__o8jC7"};